/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureBackupApplicationsResponse {
  /**
  * The application ID of the key vault access app registration. May be empty if no key vault access app is found. 
  */
  'keyVaultAccessAppId'?: string;
  /**
  * The application ID of the management app registration. May be empty if no management app is found. 
  */
  'managementAppId'?: string;
  /**
  * The application ID of the backup app registration. May be empty if no backup app is found or if accountType is not provided. 
  */
  'backupAppId'?: string;
  /**
  * The customer\'s Azure tenant ID. This is the first tenant ID found from the returned applications that is not the Eon tenant. May be empty if no customer tenant is found. 
  */
  'customerTenantId'?: string;
  /**
  * The managed identity principal ID of the ADX cluster. May be empty if no ADX cluster is found. 
  */
  'adxClusterManagedIdentityPrincipalId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "keyVaultAccessAppId",
      "baseName": "keyVaultAccessAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "managementAppId",
      "baseName": "managementAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "backupAppId",
      "baseName": "backupAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "customerTenantId",
      "baseName": "customerTenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "adxClusterManagedIdentityPrincipalId",
      "baseName": "adxClusterManagedIdentityPrincipalId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return AzureBackupApplicationsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

